// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const ModalBody = createStyle({
  px: '$4',
  paddingTop: 0,
  paddingBottom: '$2',
});
